<template>
  <div id="header">
    <div class="header">
      <div class="header_left">
        <img src="http://open.beijing.gov.cn/common/images/icon/opbj.png" />
        <div>{{ ProjectName }}</div>
      </div>
      <div class="header_main"></div>
      <div class="header_right">
        <el-avatar><i class="el-icon-user-solid"></i></el-avatar>
        <el-dropdown trigger="click">
          <div style="display:flex">
            <div class="header_right_text">{{ UserName }}</div>
            <div class="el-icon-caret-bottom"></div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-user-solid">
              <span @click="handleClick('Back')">用户中心</span>
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-s-promotion">
              <span @click="handleClick('signOut')">安全退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  setup () { },
  data () {
    return {
      ProjectName: process.env.VUE_APP_Project_Name,
      UserName: "管理员",
    };
  },
  created () {
    if (JSON.parse(sessionStorage.getItem("user"))) {
      this.UserName = JSON.parse(sessionStorage.getItem("user")).account
    }
  },
  methods: {
    handleClick (type) {
      if (type == 'signOut') {
        sessionStorage.clear();
        window.location.href = '/web/userCenter/';
      } else {
        window.location.href = '/web/userCenter/#/Usercenter';
      }
    },
  }
};
</script>

<style scoped>
#header {
  width: 100%;
  min-width: 1200px;
  height: 61px;
  background: #bd1a2d;
  margin-bottom: 20px;
}

.header {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.header_left {
  height: 100%;
  flex: 1.7;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-size: 20px;
  color: #fff;
  font-weight: bold;
}

.header_left img {
  height: 60px;
  width: 60px;
  margin-right: 20px;
}

.header_main {
  flex: 5;
}

.el-menu--horizontal {
  background: #bd1a2d;
  border: none;
}

.header_right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: #fff;
}

.header_right img {
  height: 30px;
  width: 30px;
}

.header_right_text {
  cursor: pointer;
  color: #fff;
  margin-right: 8px;
  font-size: 14px;
  max-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .el-submenu .el-submenu__title {
  color: white !important;
  padding: 0px 11px;
}

::v-deep .is-active .el-submenu__title {
  border-bottom-color: white !important;
}

::v-deep .el-submenu .el-submenu__title:hover {
  background: #ae1529 !important;
}

::v-deep .el-submenu__title:hover,
.liClasss:hover,
.el-menu-item:hover {
  background: #ae1529 !important;
}

::v-deep .el-menu--horizontal .el-menu .el-menu-item .is-active {
  color: white !important;
  border-bottom: none;
}

::v-deep .el-menu--horizontal>.el-menu-item.is-active {
  border-color: white !important;
}

::v-deep .el-menu.el-menu--horizontal {
  border-bottom: solid 0px #e6e6e6;
}
</style>
